module.exports = __webpack_public_path__ + "img/工作反馈.62b30da7.svg";